import { Award, Clock, Shield } from 'lucide-react';
import QRCodeCard from '../QRCodeCard';

const trustBadges = [
  { id: 'experience', icon: Award, text: "20 Ans d'Expérience" },
  { id: 'guarantee', icon: Shield, text: 'Satisfaction Garantie' },
  { id: 'estimate', icon: Clock, text: 'Estimation Gratuite' }
];

const TrustBadges = () => (
  <div className="trust-badges-container">
    <div className="trust-badges">
      {trustBadges.map((badge) => {
        const Icon = badge.icon;
        return (
          <div key={badge.id} className="trust-badge">
            <Icon size={20} className="trust-badge-icon" />
            <span>{badge.text}</span>
          </div>
        );
      })}
    </div>
    <QRCodeCard className="qr-code-hero" />
  </div>
);

export default TrustBadges;
